import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import AnimatedHandle
  from '@components/pages/ShopV3/components/Sidebar/components/Drawer/AnimatedHandle';
import styles from './SortByMobile.module.scss';
import { defaultSortOption, sortOptions } from '../../util/sortOptions';

interface ISortBy {
  className?: string;
}

const SortByMobile = ({
  className = ''
}: ISortBy) => {
  const router = useRouter();

  const activeOption = useMemo(() => {
    return router.query.sort || defaultSortOption.sort;
  }, [router.query]);

  const [selectedOption, setSelectedOption] = useState(activeOption);
  const [isOpen, setIsOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleOpenDrawer = () => {
    if (isOpen) {
      setIsOpen(false);
      setTimeout(() => setIsCollapsed(true), 250);
    } else {
      setIsCollapsed(false);
      setTimeout(() => setIsOpen(true), 100);
    }
  };

  useEffect(() => {
    if (selectedOption === defaultSortOption.sort) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { sort, ...query } = router.query;
      router.push({ query });
    } else {
      router.push({
        query: {
          ...router.query,
          sort: selectedOption
        }
      });
    }
  }, [selectedOption]);

  return (
    <div className={`${className}`}>
      <div className={styles.FilterButton}>
        <AnimatedHandle
          handleDrawerOpened={handleOpenDrawer}
          isActive={isOpen}
          title={'Sort by'}
        />
      </div>

      <ul
        className={classNames(styles.FilterList, styles.TopLevel, {
          [styles.Expanded]: isOpen,
          [styles.Collapsed]: isCollapsed,
        })}
      >
        {sortOptions.map((option) => (
          <li key={option.sort} className={styles.FilterItem}>
            <label htmlFor={option.label} className={styles.Checkbox}>
              <div
                className={classNames(styles.Checkmark, {
                  [styles.Checked]: activeOption === option.sort,
                })}
              />
              <div className={styles.Button}>{option.label}</div>
              <input
                id={option.label}
                name="sort-options"
                type="radio"
                checked={activeOption === option.sort}
                onChange={() => setSelectedOption(option.sort)}
              />
            </label>
          </li>
        ))}
      </ul>
      <div className={styles.Divider} />
    </div>
  );
};

export default SortByMobile;
